import { render, staticRenderFns } from "./UserProfilePagePreview.vue?vue&type=template&id=b90dbdb6&"
import script from "./UserProfilePagePreview.vue?vue&type=script&lang=js&"
export * from "./UserProfilePagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports